import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function FooterCentered({ section, data, theme, rsvpRef }) {
  const anim = section.animation || {};

  const scrollToRSVP = () => rsvpRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <section className="px-5 py-24 text-center" data-testid="footer-section">
      <div className="max-w-sm mx-auto">
        <AnimatedSection preset={anim.section || 'fade-up'}>
          <div className="w-12 h-px mx-auto mb-8" style={{ background: theme.accent, opacity: 0.4 }} />
          <p className="text-sm leading-relaxed mb-2" style={{ color: theme.textSecondary }}>
            {data.closingMessage || "We can't wait to celebrate with you"}
          </p>
          <h2
            className="text-2xl sm:text-3xl font-light mb-8"
            style={{ color: theme.textPrimary, fontFamily: theme.headingFont }}
          >
            {data.names || 'See you there'}
          </h2>
        </AnimatedSection>
        <AnimatedSection preset={anim.section || 'fade-up'} delay={0.15}>
          <button
            onClick={scrollToRSVP}
            className="px-10 py-3.5 rounded-full text-xs font-medium tracking-widest uppercase transition-all hover:scale-105"
            style={{
              background: theme.accent,
              color: '#fff',
              fontFamily: theme.eyebrowFont,
              boxShadow: `0 4px 20px ${theme.accent}44`,
            }}
            data-testid="footer-rsvp-cta"
          >
            RSVP Now
          </button>
        </AnimatedSection>
        <AnimatedSection preset="fade-in" delay={0.3}>
          <p className="mt-12 text-xs" style={{ color: theme.textSecondary, opacity: 0.5, fontFamily: theme.eyebrowFont }}>
            {data.contactText || 'Made with love'}
          </p>
        </AnimatedSection>
      </div>
      <div className="h-20" />
    </section>
  );
}
